module.exports = __webpack_public_path__ + "73eec693c23fafa81b740155b41338f8.pdf";